<lns-card [cardType]="cardType.White">
  <ng-container *ngIf="bankCardData">
    <div class="card-info" fxLayoutAlign="start start">
      <div class="dot"></div>
      <div>
        <p class="title">{{ bankCardData.cardName }}</p>
        <p class="subtitle text-gray">
          {{ bankCardData.maskCardNumber }}
        </p>
      </div>
    </div>
    <div class="img-placeholder mb-60">
      <lns-credit-card [bankCardData]="bankCardData"></lns-credit-card>
    </div>
    <div
      fxLayout="column"
      fxLayoutAlign="start start"
      *ngIf="
        bankCardData.cardType == cardType.Credit ||
        bankCardData.cardType == cardType.Prepaid
      "
    >
      <p class="balance-title text-gray">
        {{ 'cards_available_current_balance' | translate }}
      </p>
      <div class="price" fxLayoutAlign="start center" fxLayoutGap="8px">
        <div
          [lnsAccountBalance]="bankCardData.currentBalance"
          class="price__value"
        ></div>
        <span class="price__currency">{{
          bankCardData.currency ? bankCardData.currency : currency.Eur
        }}</span>
      </div>
    </div>
  </ng-container>
</lns-card>
